const diaryViewKeys = {
  LISTDAY: 1,
  LISTWEEK: 2,
  LISTMONTH: 3,
  LISTYEAR: 4,
  TIMEGRIDDAY: 5,
  TIMEGRIDWEEK: 6,
  DAYGRIDMONTH: 7
};

const diaryViewCodes = {
  LISTDAY: 'DAY',
  LISTWEEK: 'WEEK',
  LISTMONTH: 'MONTH',
  LISTYEAR: 'YEAR',
};

const diaryViewValues = [
  {id: diaryViewKeys.LISTDAY, name: 'SI_DAY', code: diaryViewCodes.LISTDAY},
  {id: diaryViewKeys.LISTWEEK, name: 'SI_WEEK', code: diaryViewCodes.LISTWEEK},
  {id: diaryViewKeys.LISTMONTH, name: 'SI_MONTH', code: diaryViewCodes.LISTMONTH},
  {id: diaryViewKeys.LISTYEAR, name: 'SI_EVENTS', code: diaryViewCodes.LISTYEAR}
];

const diaryViewIds = {
  LIST_DAY: diaryViewKeys.LISTDAY,
  LIST_WEEK: diaryViewKeys.LISTWEEK,
  LIST_MONTH: diaryViewKeys.LISTMONTH,
  LIST_YEAR: diaryViewKeys.LISTYEAR,
  TIME_GRID_DAY: diaryViewKeys.TIMEGRIDDAY,
  TIME_GRID_WEEK: diaryViewKeys.TIMEGRIDWEEK,
  DAY_GRID_MONTH: diaryViewKeys.DAYGRIDMONTH
};

const diaryViewFullCalendar = {
  [diaryViewIds.LIST_DAY]: 'listDay',
  [diaryViewIds.LIST_WEEK]: 'listWeek',
  [diaryViewIds.LIST_MONTH]: 'listMonth',
  [diaryViewIds.LIST_YEAR]: 'listYear',
  [diaryViewIds.TIME_GRID_DAY]: 'timeGridDay',
  [diaryViewIds.TIME_GRID_WEEK]: 'timeGridWeek',
  [diaryViewIds.DAY_GRID_MONTH]: 'dayGridMonth'
};

const diaryEventTypes = {
  VITAL_SIGNS: 1,
  MEDICATION: 2,
  GENERIC_EVENT: 3
};

const diaryEventTypeCodes = {
  VITAL_SIGNS: 'VITAL_SIGNS',
  MEDICATION: 'MEDICATION',
  GENERIC_EVENT: 'GENERIC_EVENT'
};

const diaryEventTypeIcons = {
  VITAL_SIGNS: 'icosun-heart_pulse',
  MEDICATION: 'icon-medication',
  GENERIC_EVENT: 'icosun-calendar'
};

const diaryEventTypeValues = [
  {
    id: diaryEventTypes.VITAL_SIGNS,
    code: diaryEventTypeCodes.VITAL_SIGNS,
    name: 'SI_VITAL_SIGNS'
  },
  {
    id: diaryEventTypes.MEDICATION,
    code: diaryEventTypeCodes.MEDICATION,
    name: 'SI_MEDICATION'
  },
  {
    id: diaryEventTypes.GENERIC_EVENT,
    code: diaryEventTypeCodes.GENERIC_EVENT,
    name: 'SI_GENERIC_EVENT'
  }
];

const diaryEventStatus = {
  DONE: 1,
  PENDING: 2,
  NOT_DONE: 3
};

const diaryEventStatusCodes = {
  DONE: 'DONE',
  PENDING: 'PENDING',
  NOT_DONE: 'NOT_DONE'
};

const diaryEventStatusValues = [
  {
    id: diaryEventStatus.DONE,
    code: diaryEventStatusCodes.DONE,
    name: 'SI_DONE'
  },
  {
    id: diaryEventStatus.PENDING,
    code: diaryEventStatusCodes.PENDING,
    name: 'SI_PENDING'
  },
  {
    id: diaryEventStatus.NOT_DONE,
    code: diaryEventStatusCodes.NOT_DONE,
    name: 'SI_NOT_DONE'
  }
];

const diaryEventTypeValueFromCode = {
  [diaryEventTypeCodes.VITAL_SIGNS]: diaryEventTypeValues[0],
  [diaryEventTypeCodes.MEDICATION]: diaryEventTypeValues[1],
  [diaryEventTypeCodes.GENERIC_EVENT]: diaryEventTypeValues[2],
};

const diaryEventPeriodicityTypeCodes = {
  NO_REPEAT: 'NO_REPEAT',
  EVERY_DAY: 'EVERY_DAY',
  EVERY_WEEK: 'EVERY_WEEK',
  EVERY_MONTH: 'EVERY_MONTH',
  CUSTOMIZED: 'CUSTOMIZED'
};

const diaryEventNotificationTypeCodes = {
  TYPE_NO_NOTIFICATION: 'TYPE_NO_NOTIFICATION',
  TYPE_5_MINUTES: 'TYPE_5_MINUTES',
  TYPE_10_MINUTES: 'TYPE_10_MINUTES',
  TYPE_15_MINUTES: 'TYPE_15_MINUTES',
  TYPE_1_HOUR: 'TYPE_1_HOUR',
  TYPE_1_DAY: 'TYPE_1_DAY'
};

const diaryEventFrequencyTypes = {
  SIMPLE: 'EVENT',
  SERIE: 'SERIE'
};

export {
  diaryViewFullCalendar,
  diaryViewIds,
  diaryViewKeys,
  diaryViewValues,
  diaryEventTypeValues,
  diaryEventTypeCodes,
  diaryEventTypes,
  diaryEventStatusValues,
  diaryEventStatusCodes,
  diaryEventStatus,
  diaryEventTypeIcons,
  diaryEventTypeValueFromCode,
  diaryEventPeriodicityTypeCodes,
  diaryEventNotificationTypeCodes,
  diaryEventFrequencyTypes
};
